export interface TermSheetFormState {
  accepted: boolean;
  saving: boolean;
  loading: boolean;
  existingTermSheet: any;
  loanType: string;
  sbaType: string;
  sbaFee: string;
  sbaCap: string;
  facilityType: string;
  loanAmount: string;
  tenorYears: string;
  tenorMonths: string;
  repaymentSchedule: string;
  repaymentYears: string;
  repaymentMonths: string;
  pricing: string;
  fees: string;
  collateral: string;
  guaranty: string;
  bankerName: string;
  errors: TermSheetErrors;
}

export interface TermSheetErrors {
  loanTypeError: string;
  sbaTypeError: string;
  facilityTypeError: string;
  loanAmountError: string;
  tenorYearsError: string;
  tenorMonthsError: string;
  repaymentYearsError: string;
  repaymentMonthsError: string;
  pricingError: string;
  feesError: string;
  collateralError: string;
  guarantyError: string;
}

export type TermSheetAction =
  | { type: "SET_FIELD"; field: keyof TermSheetFormState; value: any }
  | { type: "SET_ERROR"; field: keyof TermSheetErrors; value: string }
  | { type: "CLEAR_ERRORS" }
  | { type: "RESET_FORM"; defaultFacilityType: string; defaultLoanAmount: string }
  | { type: "LOAD_TERMSHEET"; payload: Partial<TermSheetFormState> & { existingTermSheet: any } };

export const initialTermSheetState: TermSheetFormState = {
  accepted: false,
  saving: false,
  loading: false,
  existingTermSheet: null,
  loanType: "",
  sbaType: "",
  sbaFee: "",
  sbaCap: "",
  facilityType: "",
  loanAmount: "",
  tenorYears: "",
  tenorMonths: "",
  repaymentSchedule: "",
  repaymentYears: "",
  repaymentMonths: "",
  pricing: "",
  fees: "",
  collateral: "",
  guaranty: "",
  bankerName: "",
  errors: {
    loanTypeError: "",
    sbaTypeError: "",
    facilityTypeError: "",
    loanAmountError: "",
    tenorYearsError: "",
    tenorMonthsError: "",
    repaymentYearsError: "",
    repaymentMonthsError: "",
    pricingError: "",
    feesError: "",
    collateralError: "",
    guarantyError: "",
  },
};

export function termSheetReducer(state: TermSheetFormState, action: TermSheetAction): TermSheetFormState {
  switch (action.type) {
    case "SET_FIELD":
      return { ...state, [action.field]: action.value };
    case "SET_ERROR":
      return { ...state, errors: { ...state.errors, [action.field]: action.value } };
    case "CLEAR_ERRORS":
      return {
        ...state,
        errors: Object.keys(state.errors).reduce((acc, key) => {
          acc[key as keyof TermSheetErrors] = "";
          return acc;
        }, {} as TermSheetErrors),
      };
    case "RESET_FORM":
      return {
        ...initialTermSheetState,
        facilityType: action.defaultFacilityType,
        loanAmount: action.defaultLoanAmount,
      };
    case "LOAD_TERMSHEET":
      const { existingTermSheet, ...rest } = action.payload;
      return {
        ...state,
        ...rest,
        existingTermSheet,
      };
    default:
      return state;
  }
}